import {Component, Input, OnInit} from '@angular/core';
import {ProductModel} from "../../../../orders/models/product.model";
import {OrderModel} from "../../../../orders/models/order.model";
import {ContactType} from "../../../DTO/contactType";
import {ArticleFamilyConstants} from "../../../constants/articles-family.constants";
import {SubjectRole} from "../../../DTO/subjectRole";
import {IdentificationTypeConstants} from "../../../constants/identificationType.constants";

@Component({
  selector: 'app-recognition-flow-info-box',
  templateUrl: './recognition-flow-info-box.component.html',
  styleUrls: ['./recognition-flow-info-box.component.scss']
})
export class RecognitionFlowInfoBoxComponent implements OnInit {
  @Input() minimizedReview: boolean;
  IdentificationTypeConstants = IdentificationTypeConstants;
  ArticleFamilyConstants = ArticleFamilyConstants;
  SubjectRole = SubjectRole;
  ContactType = ContactType;
  @Input() data: any;
  @Input() product: ProductModel;
  @Input() order: OrderModel;
  constructor() { }

  ngOnInit(): void {
    console.log('mallow', this.order);
    console.log('mallow', this.product);
  }

}
